/**
* 供货管理 供货提现
*/
<template>
  <div class="contianer">
    <div class="mt20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订单提现" name="first">
          <div class="flex_box mt10">
<!--            <div class="flex_box">-->
<!--              <div class="wable mr50" style="background-color: rgba(173, 216, 230, 0.1);">-->
<!--                <p class="color409EFF f36 hide">￥{{wait_allocate_money}}</p>-->
<!--                <p class="f14 color666 mt5">可提现金额</p>-->
<!--              </div>-->
<!--              <div class="wable" style="background-color: rgba(153, 204, 0, 0.1);">-->
<!--                <p class="color66BA3F f36 hide">￥{{allocated_money}}</p>-->
<!--                <p class="f14 color666 mt5">提现中金额</p>-->
<!--              </div>-->
<!--            </div>-->
            <div class="wable flex_between">
              <div>
                <div>
                  <p class="f14 color666">可提现金额</p>
                  <p class="color409EFF f16 hide mt10">￥{{wait_allocate_money}}</p>
                </div>
                <div class="mt10">
                  <p class="f14 color666">提现中金额</p>
                  <p class="color66BA3F f16 hide mt10">￥{{allocated_money}}</p>
                </div>
              </div>
              <div>
                <el-button type="primary" size="mini" @click="billHand()" :disabled="sfvalue">提现</el-button>
              </div>
            </div>
            <div class="wable flex_between" style="margin-left: 10px">
              <p class="f16 lh28 ml200 mr10">是否自动提现</p>
              <el-switch @change="changeBillSetManual()"
                         v-model="sfvalue">
              </el-switch>
            </div>
          </div>
          <!-- 订单提现 -->
          <div class="mt20">
            <el-form :inline="true" :model="formInline" class="user-search">
              <el-form-item label="">
                <el-date-picker
                  v-model="searchDate"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="formInline.process_status" placeholder="提现状态" clearable>
                  <el-option label="未处理" value="0"></el-option>
                  <el-option label="已处理" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="search">查询</el-button>
                <el-button size="small" type="success" @click="exportExcel()">导出</el-button>
<!--                <el-button size="small" type="warning">提现记录</el-button>-->
              </el-form-item>
            </el-form>
            <!--列表-->
            <div style="height: 500px;overflow-y: auto">
              <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                        @selection-change="handleSelectionChange"
                        :default-sort="{prop: 'process_status', order: 'ascending'}"
                        element-loading-text="拼命加载中" style="width: 80%;">
                <el-table-column align="center" type="selection" width="80">
                </el-table-column>
                <el-table-column
                  label="序号"
                  width="60">
                  <template slot-scope="scope">
                    {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column prop="bill_type" label="单据类型" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.bill_type==2500">入账</div>
                    <div v-else="scope.row.bill_type==2501">出账</div>
                  </template>
                </el-table-column>
                <el-table-column prop="source_code" label="单据编号" min-width="160" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column prop="create_time" label="单据创建时间" width="135">
                </el-table-column>
                <el-table-column prop="order_amount" label="实付金额" width="120">
                  <template slot-scope="scope">
                    <div v-if="scope.row.bill_type==2500">￥{{scope.row.order_amount}}</div>
                    <div v-if="scope.row.bill_type==2501">￥0</div>
                  </template>
                </el-table-column>
                <el-table-column prop="refund_amount" label="退款金额" width="120">
                  <template slot-scope="scope">
                    <div>￥{{scope.row.refund_amount}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="original_pay_amount" label="可提现金额" width="120">
                  <template slot-scope="scope">
                    <div>￥{{scope.row.original_pay_amount}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="process_status" sortable label="处理状态" width="100">
                  <template slot-scope="scope">
                    <div plain style="color: #409EFF" v-if="scope.row.process_status=='1'">已处理</div>
                    <div plain style="color: #F56C6C" v-else-if="scope.row.process_status=='0'">未处理</div>
                  </template>
                </el-table-column>
                <el-table-column prop="original_order_code" label="关联账单编号" min-width="160"
                                 :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    <div class="over_text_1" v-if="scope.row.bill_type==2500">{{scope.row.ref_bill_codes}}</div>
                    <div class="over_text_1" v-else>{{scope.row.original_order_code}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </div>
        </el-tab-pane>
        <!-- 提现记录 -->
        <el-tab-pane label="提现记录" name="second" v-if="agent_type=='2891'">
          <div class="mt20">
            <el-form :inline="true" :model="formInline1" class="user-search">
              <el-form-item label="">
                <el-date-picker
                  v-model="searchDate1"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="formInline1.withdrawStatus" placeholder="处理状态" clearable>
                  <el-option label="处理中" value="0"></el-option>
                  <el-option label="处理成功" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="search1">查询</el-button>
<!--                <el-button size="small" type="warning">提现记录</el-button>-->
              </el-form-item>
            </el-form>
            <!--列表-->
            <div style="height: 550px;overflow-y: auto">
              <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                        element-loading-text="拼命加载中" style="width: 60%;">
                <el-table-column align="center" type="selection" width="80">
                </el-table-column>
                <el-table-column
                  label="序号"
                  width="60">
                  <template slot-scope="scope">
                    {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column prop="create_time" label="提现日期" width="135">
                  <template slot-scope="scope">
                    <div>{{scope.row.create_time|timestampToTime}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="withdraw_code" label="单据编号" min-width="160">
                </el-table-column>
                <el-table-column prop="withdraw_amount" label="提现金额" width="120">
                  <template slot-scope="scope">
                    <div>￥{{scope.row.withdraw_amount}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="process_status" label="处理状态" width="120">
                  <template slot-scope="scope">
                    <div plain style="color: #F56C6C" v-if="scope.row.withdraw_status=='0'">处理中</div>
                    <div plain style="color: #409EFF" v-else>处理成功</div>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini"
                               @click="detailApply(scope.row.withdraw_status,scope.row.withdraw_code,scope.row.id)">
                      查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 手动提现弹窗 -->
    <el-dialog :visible.sync="billDialogVisible"
               width="60%"
               center>
      <div>
        <p class="f20 color333 fontWeight mb10">提现账户信息</P>
        <div class="flex_box mb10">
          <div class="order_no item f15">
            <p class="color333 inline mr12">开户银行名称</p>
            <span class="color666">{{billDetailData.bank}}</span>
          </div>
        </div>
        <div class="flex_box mb10">
          <div class="order_no item f15">
            <p class="color333 inline mr12">基本开户账号</p>
            <span class="color666">{{billDetailData.bank_account}}</span>
          </div>
        </div>
        <p class="f15 color409EFF">温馨提示：每天仅能提现一次，请仔细核对确认提现账户信息</p>
      </div>
      <!-- 提现列表 -->
      <div class="mt30">
        <p class="f20 color333 fontWeight mb10">提现金额</P>
        <el-table size="small" :data="withdrawalData"
                  highlight-current-row v-loading="loading" show-summary
                  :summary-method="getSendSummaries" :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="bill_type" label="单据类型" width="90">
            <template slot-scope="scope">
              <div v-if="scope.row.bill_type==2500">入账</div>
              <div v-else="scope.row.bill_type==2501">出账</div>
            </template>
          </el-table-column>
          <el-table-column prop="source_code" label="单据编号" min-width="160">
          </el-table-column>
          <el-table-column prop="create_time" label="单据创建时间" width="135">
          </el-table-column>
          <el-table-column prop="order_amount" label="实付金额" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.bill_type==2500">￥{{scope.row.order_amount}}</div>
              <div v-if="scope.row.bill_type==2501">￥0</div>
            </template>
          </el-table-column>
          <el-table-column prop="refund_amount" label="退款金额" width="100">
            <template slot-scope="scope">
              <div>￥{{scope.row.refund_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="original_pay_amount" label="可提现金额" width="120">
            <template slot-scope="scope">
              <div>￥{{scope.row.original_pay_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="original_order_code" label="关联账单编号" min-width="160" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div class="over_text_1" v-if="scope.row.bill_type==2500">{{scope.row.ref_bill_codes}}</div>
              <div class="over_text_1" v-else>{{scope.row.original_order_code}}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block" style="margin-top: 15px">
          <Pagination v-bind:child-msg="withdrawalPageparm" @callFather="callFather3"></Pagination>
        </div>
      </div>
      <div style="text-align: center">
        <el-button size="small" @click="billDialogVisible = false">关 闭</el-button>
        <el-button size="small" type="primary" @click="sureBillWithdraw()">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 订单提现-处理失败 -->
    <el-dialog :visible.sync="failedDialogVisible" width="40%" center>
      <p class="f20 color409EFF fontWeight" style="text-align: center;">处理失败</p>
      <p class="f15 color333 mt10" style="text-align: center;">{{greadData.withraw_code}}<span class="ml10">部分失败</span>
      </p>
      <!-- 提现失败列表 -->
      <div class="mt30">
        <el-table size="small" :data="detaiSendData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                  show-summary highlight-current-row v-loading="loading"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="source_code" label="单据编号" min-width="120">
          </el-table-column>
          <el-table-column prop="create_time" label="单据创建时间" width="190">
          </el-table-column>
          <el-table-column prop="original_pay_amount" label="可提现金额" width="120">
            <template slot-scope="scope">
              <div>￥{{scope.row.original_pay_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="失败原因" width="120">
            银联处理失败
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block" style="margin-top: 15px;text-align: center;">
          <el-pagination
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="detaiSendData.length"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog :visible.sync="detailDialogVisible"
               width="60%"
               center>
      <div>
        <p class="f20 color333 fontWeight mb10">提现详情</P>
        <div class="flex_box">
          <div class="state">
            <p class="f15 color333" style="margin-top: 30%;">处理状态</p>
            <p class="f24 color409EFF">{{withdraw_status?'处理成功':'处理中'}}</p>
          </div>
          <div class="ml30 br8" style="border: 1px solid #EBEEF5">
            <div class="flex_box bb1">
              <div class="order_no flex_box item f15">
                <p class="label color333 inline mr12" style="border-radius: 8px 0 0 0;">单据号</p>
                <p class="billing_item"><span class="color666">{{withdraw_code}}</span></p>
              </div>
            </div>
            <div class="flex_box bb1">
              <div class="order_no flex_box item f15">
                <p class="label color333 inline mr12">开户银行名称</p>
                <p class="billing_item"><span class="color666">{{billDetailData.bank}}</span></p>
              </div>
            </div>
            <div class="flex_box">
              <div class="order_no flex_box item f15">
                <p class="label color333 inline mr12" style="border-radius: 0 0 0 8px;">基本开户账号</p>
                <p class="billing_item"><span class="color666">{{billDetailData.bank_account}}</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 提现失败列表 -->
      <div class="mt20" v-if="biolSendData.length&&!withdraw_status">
        <el-table size="small" :data="biolSendData"
                  highlight-current-row v-loading="loading" show-summary
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 80%; height: 171px;">
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="source_code" label="单据编号" min-width="160">
          </el-table-column>
          <el-table-column prop="create_time" label="单据创建时间" width="135">
            <template slot-scope="scope">
              <div>{{scope.row.create_time|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="wait_allocate_amount" label="可提现金额" width="160">
            <template slot-scope="scope">
              <div>￥{{scope.row.wait_allocate_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="allocated_desc" label="失败原因" min-width="160">
          </el-table-column>
        </el-table>
      </div>
      <!-- 提现详情列表 -->
      <div class="mt30">
        <div class="flex_box mb20">
          <p class="f20 color333 fontWeight mb10 mr10">提现金额</P>
          <el-row>
            <el-button size="mini" type="warning" @click="exportExceldetail()" plain>导出明细</el-button>
          </el-row>
        </div>
        <!-- 查看详情搜索筛选 -->
        <el-form :inline="true" :model="formInline4" class="user-search">
          <el-form-item label="">
            <el-select v-model="formInline4.allocated_status" placeholder="入驻商分账状态" clearable>
              <el-option label="处理中" value="2400"></el-option>
              <el-option label="处理成功" value="2402"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline4.divided_status" placeholder="服务费分账状态" clearable>
              <el-option label="处理中" value="2400"></el-option>
              <el-option label="处理成功" value="2402"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="detailSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table size="small" :data="listData4"
                  highlight-current-row v-loading="loading" show-summary
                  :summary-method="getSendSummaries1" :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="bill_type" label="单据类型" width="90">
            <template slot-scope="scope">
              <div v-if="scope.row.bill_type==2500">入账</div>
              <div v-else="scope.row.bill_type==2501">出账</div>
            </template>
          </el-table-column>
          <el-table-column prop="source_code" label="单据编号" min-width="160" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="create_time" label="单据创建时间" width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="order_amount" label="实付金额" width="100" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div v-if="scope.row.bill_type==2500">￥{{scope.row.order_amount}}</div>
              <div v-if="scope.row.bill_type==2501">￥0</div>
            </template>
          </el-table-column>
          <el-table-column prop="refund_amount" label="退款金额" width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>￥{{scope.row.refund_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="original_pay_amount" label="订单可提现金额" width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>￥{{scope.row.original_pay_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="original_order_code" label="关联账单编号" min-width="160" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div class="over_text_1" v-if="scope.row.bill_type==2500">{{scope.row.ref_bill_codes}}</div>
              <div class="over_text_1" v-else>{{scope.row.original_order_code}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="company_name" label="客户单位" width="120" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="allocated_status" label="入驻商分账状态" width="120">
            <template slot-scope="scope">
              <div plain style="color: #F56C6C" v-if="scope.row.allocated_status=='2400'">处理中</div>
              <div plain style="color: #409EFF" v-else>处理成功</div>
            </template>
          </el-table-column>
          <el-table-column prop="divided_status" label="服务费分账状态" width="120">
            <template slot-scope="scope">
              <div plain style="color: #F56C6C" v-if="scope.row.divided_status=='2400'">处理中</div>
              <div plain style="color: #409EFF" v-else>处理成功</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block" style="margin-top: 15px;text-align: center;">
          <Pagination v-bind:child-msg="pageparm4" @callFather="callFather4"></Pagination>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    billFlow,
    billWithdraw,
    billWithdrawRecordList,
    billSetManual,
    billWithdrawDetailList,
    billWithdrawFailList,
    billWithdrawDetailExport,
    billFlowExport,
    billBankinfo,
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, // 是显示加载
        sfvalue: false,
        detailVisible: false, // 订单提现
        applyVisible: false,  // 提现记录
        billDialogVisible: false, // 提现弹窗
        detailDialogVisible: false, // 详情弹窗
        failedDialogVisible: false, // 处理失败弹窗
        searchDate: '',
        searchDate1: '',
        billSendData: [], // 手动提现列表
        detaiSendData: [], // 处理失败列表
        failSendData: [], // 提现详情失败列表
        biolSendData: [], // 提现详情列表
        selectTableData: [],
        gridData: {},
        greadData: {},
        formInline: {
          page: 1,
          rows: 10,
          order_code: '',
          begin_time: '',
          end_time: '',
          is_flows: '',
          process_status: '',
          withdrawal_record_id: ''
        },
        formInline1: {
          page: 1,
          rows: 10,
          startDate: '',
          endDate: '',
          withdrawStatus: '',
        },
        formInline3: {
          page: 1,
          rows: 10,
          order_code: '',
          begin_time: '',
          end_time: '',
          is_flows: '',
          process_status: 0,
          withdrawal_record_id: ''
        },
        formInline4: {
          page: 1,
          rows: 10,
          recordId: '',
          allocated_status: '',
          divided_status: ''
        },
        detailData: {},
        billDetailData: {},
        tokenId: '',
        activeName: 'first',
        listData: [], //用户数据
        listData1: [], //用户数据
        listData4: [], // 查看详情成功用户数据
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        withdrawalPageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm4: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        withdrawalData: [],
        wait_allocate_money: '0.00',
        allocated_money: '0.00',
        withdraw_status: 0,
        withdraw_code: '',
        agent_type: localStorage.getItem('agent_type') || '2891',
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表1-0
      getData(parameter) {
        this.loading = true
        billFlow(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
              this.wait_allocate_money = res.attrs.waitAllocateMoney;
              this.allocated_money = res.attrs.withdrawingMoney;
              if (res.attrs.is_manual) {
                if (res.attrs.is_manual == 1) {
                  this.sfvalue = true;
                } else {
                  this.sfvalue = false;
                }
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getData(this.formInline)
      },
      // 获取公司列表1-1
      getData1(parameter) {
        this.loading = true
        billWithdrawRecordList(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.totalSize
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getData1(this.formInline1)
      },
      callFather3(parm) {
        this.formInline3.page = parm.currentPage
        this.formInline3.rows = parm.pageSize
        this.billHand(this.formInline3)
      },
      callFather4(parm) {
        this.formInline4.page = parm.currentPage
        this.formInline4.rows = parm.pageSize
        this.getWithdrawaldetail(this.formInline4)
      },
      // 搜索事件
      search() {
        if (this.searchDate) {
          this.formInline.begin_time = timestampToDate(this.searchDate[0])
          this.formInline.end_time = timestampToDate(this.searchDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getData(this.formInline)
      },
      search1() {
        if (this.searchDate1) {
          this.formInline1.startDate = timestampToDate(this.searchDate1[0])
          this.formInline1.endDate = timestampToDate(this.searchDate1[1])
        } else {
          this.formInline1.startDate = ''
          this.formInline1.endDate = ''
        }
        this.formInline1.page = 1;
        this.getData1(this.formInline1)
        console.log(this.formInline1)
      },
      // 查看详情搜索事件
      detailSearch() {
        this.formInline4.page = 1;
        this.getWithdrawaldetail(this.formInline4)
        console.log(this.formInline4)
      },
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getData(this.formInline)
        } else if (tab.index == 1) {
          this.getData1(this.formInline1)
        }
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 手动提现
      billHand() {
        this.billSendData = this.selectTableData
        this.currentPage = 1;
        this.billDialogVisible = true
        billBankinfo()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.billDetailData = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        billFlow(this.formInline3)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.withdrawalData = res.content.rows
              // 分页赋值
              this.withdrawalPageparm.currentPage = this.formInline3.page
              this.withdrawalPageparm.pageSize = this.formInline3.rows
              this.withdrawalPageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      sureBillWithdraw() {
        billWithdraw()
          .then(res => {
            this.loading = false;
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.billDialogVisible = false;
              this.$message({
                type: 'success',
                message: '您已成功提现!'
              });
              this.getData(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      changeBillSetManual() {
        let manualValue = null
        if (this.sfvalue) {
          manualValue = 1
        } else {
          manualValue = 0
        }
        billSetManual(manualValue)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '设置成功'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 处理失败弹窗
      clsbHand() {
        this.currentPage = 1;
        this.failedDialogVisible = true
        billWithdraw()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.greadData = res.content;
              this.detaiSendData = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 查看详情
      detailApply(withdraw_status, withdraw_code, id) {
        this.detailDialogVisible = true;
        this.withdraw_status = withdraw_status;
        this.withdraw_code = withdraw_code;
        this.formInline4.recordId = id;
        this.formInline4.page = 1;
        // 提现详情
        this.getWithdrawaldetail()
        billBankinfo()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.billDetailData = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        // 提现详情失败
        billWithdrawFailList(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.biolSendData = res.content
              this.gridData = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getWithdrawaldetail() {
        this.loading = true
        billWithdrawDetailList(this.formInline4)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData4 = res.content.rows
              // 分页赋值
              this.pageparm4.currentPage = this.formInline4.page
              this.pageparm4.pageSize = this.formInline4.rows
              this.pageparm4.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 总价
      getSendSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '退款金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '可提现金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      getSendSummaries1(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '退款金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '订单可提现金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      checkDate(date) {
        if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
          return true
        } else {
          return false
        }
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      handleSizeChange1(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleCurrentChange1(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleCurrentChange2(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      // 导出
      exportExcel() {
        billFlowExport(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '订单提现信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 导出明细
      exportExceldetail() {
        billWithdrawDetailExport(this.formInline4.recordId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '提现金额.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
    }
  };
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .head {
    width: 50%;
    justify-content: space-between;
  }

  .wable {
    width: 250px;
    background-color: rgba(173, 216, 230, 0.1);
    text-align: left;
    padding: 10px 20px 10px 10px;
  }

  .flex_between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .state {
    width: 118px;
    height: 120px;
    text-align: center;
    background: rgba(173, 216, 230, 0.3);
    border: 1px solid #EBEEF5;
    border-radius: 5px;
  }

  .hide {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .f20 {
    font-size: 20px;
  }

  .f14 {
    font-size: 14px;
  }

  .f15 {
    font-size: 15px;
  }

  .f16 {
    font-size: 16px;
  }

  .f36 {
    font-size: 36px;
  }

  .f24 {
    font-size: 24px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .color999 {
    color: #999999;
  }

  .color409EFF {
    color: #409eff;
  }

  .color66BA3F {
    color: #66BA3F;
  }

  .lh28 {
    line-height: 28px
  }

  .flex_box {
    display: flex;
  }

  .mr10 {
    margin-right: 10px;
  }

  .mr50 {
    margin-right: 50px;
  }

  .mt30 {
    margin-top: 30px;
  }

  .ml30 {
    margin-left: 30px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .mt10 {
    margin-top: 10px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .inline {
    display: inline-block;
  }

  .bb1 {
    border-bottom: 1px solid #EBEEF5;
  }

  .br8 {
    border-radius: 8px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .el-switch__core {
    margin-top: 3px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .userRole {
    width: 100%;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  /deep/ .financeForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .financeForm .el-input {
    width: 320px;
  }

  /deep/ .financeForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .financeForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .financeForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .financeForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .financeForm .el-input--small {
    width: 320px;
  }

  .tions {
    width: 50%;
  }

  .tions span {
    width: 400px;
  }

  /deep/ .tions .el-descriptions__header {
    border-bottom: 1px solid #f4f4f4;
    padding: 14px 20px;
  }

  /deep/ .tions .el-descriptions__body {
    padding: 0 20px;
  }

  /deep/ .el-dialog {
    border-radius: 8px !important;
  }

  /deep/ .el-dialog__body {
    padding: 30px 50px !important;
  }

  /deep/ .my-label {
    width: 120px !important;
    background: #EBEEF5;
  }

  /deep/ .my-content {
    width: 250px !important;
  }

  /deep/ .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 0 !important;
    border-bottom: 1px solid #F5F7FA !important;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 500px;
  }

  /deep/ .delivery .el-input--small {
    width: 500px;
  }

  /deep/ .logs .el-icon-check:before {
    color: #67C23A;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyWithdrawal.vue